import { render, staticRenderFns } from "./welcomeMessage.vue?vue&type=template&id=39cf4b10&scoped=true"
import script from "./welcomeMessage.vue?vue&type=script&lang=js"
export * from "./welcomeMessage.vue?vue&type=script&lang=js"
import style0 from "./welcomeMessage.vue?vue&type=style&index=0&id=39cf4b10&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39cf4b10",
  null
  
)

export default component.exports